export default __webpack_public_path__ + "static/media/article_3_srcdoc_placeholder.36749ae7.png";